/* eslint-disable no-undef */

export const useThemeStore = defineStore("theme", () => {
  const DEFAULT_THEME = 'light';
  const theme = ref(DEFAULT_THEME);

  // Helper function to get theme from localStorage
  function getFromLocalStorage() {
    return localStorage.getItem('theme');
  }

  // Helper function to set theme to localStorage
  function setToLocalStorage(_theme) {
    localStorage.setItem('theme', _theme);
  }

  // create init function to set theme from localStorage on load or set to light
  function init() {
    const storedTheme = getFromLocalStorage();
    if (!storedTheme) {
      setToLocalStorage(DEFAULT_THEME);
    }
    theme.value = storedTheme || DEFAULT_THEME;
  }

  // Create setTheme function that accepts theme name and sets the theme to root element data-theme attribute
  function setTheme(_theme) {
    theme.value = _theme;
    setToLocalStorage(_theme);
  }

  // Create toggleTheme function that toggles between light and dark themes
  function toggleTheme() {
    theme.value = theme.value === DEFAULT_THEME ? 'dark' : DEFAULT_THEME;
    setToLocalStorage(theme.value);
  }

  // Return setTheme and toggleTheme functions
  return {
    init,
    setTheme,
    toggleTheme,
    theme
  };
});